module.exports = __webpack_public_path__ + "img/Pack cardio.27d56f1f.png";